// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"6a3aa653","176":"5f562727","523":"0041ce30","626":"94e6c3f2","901":"37498312"}[chunkId] + ".chunk.js";
};